import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {ParamMasterDto} from '../models/dto/Commons'
import {createWhitelistFilter} from 'redux-persist-transform-filter'
import { SeasonDto } from '../models/dto/Season'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetParam: '[SetParam] Action',
  SetLastSeason:'[SetLastSeason] Action'
}
export interface ICoreState {
  paramMasters?: ParamMasterDto[],
  lastSeason?:SeasonDto
}
const initialCoreState: ICoreState = {
  paramMasters: undefined,
  lastSeason:undefined,
}
const whitelist = createWhitelistFilter('userSelected')
const saveSubsetFilter = createWhitelistFilter(`noteSate`, ['patientInfo', 'lastNoteInfo'])

export const reducer = persistReducer(
  {
    storage,
    key: 'v100-demo1-Core',
    //whitelist: ['userSelected'],
    transforms: [whitelist, saveSubsetFilter],
  },
  (state: ICoreState = initialCoreState, action: ActionWithPayload<IActoinType>) => {
    switch (action.type) {
      case actionTypes.SetParam: {
        const paramMasters = action.payload?.paramMasters
        return {
          ...state,
          paramMasters,
        }
      }
      case actionTypes.SetLastSeason:{
        const lastSeason = action.payload?.lastSeason
        return {
          ...state,
          lastSeason
        }
      }
      default:
        return state
    }
  }
)

interface IActoinType {
  paramMasters: ParamMasterDto[]
  lastSeason:SeasonDto
}

export const actions = {
  setParam: (paramMaster: ParamMasterDto[]) => ({
    type: actionTypes.SetParam,
    payload: {paramMasters: paramMaster},
  }),
  setLastSeason:(lastSeason:SeasonDto)=>({
    type:actionTypes.SetLastSeason,
    payload:{lastSeason:lastSeason}
  })
}
